import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { api } from "../api/api-hooks";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import authReducer from "../features/auth/authSlice";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
  preloadedState: (() => {
    const serializedUser = localStorage.getItem("user");
    const user = serializedUser ? JSON.parse(serializedUser) : null;
    return {
      auth: {
        user: user,
        token: localStorage.getItem("token"),
      },
    };
  })(),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
